import useMasterContext from "Context/MasterContext";
import { useEffect } from "react";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { routeToModuleMap } from "utilFunctions/Constants/Constants";

// Define NuggetChat on window
declare global {
  interface Window {
    NuggetChat: {
      destroy: any;
      toggle: any;
      init: (config: any) => void;
    };
  }
}

const NuggetChatWidget = ({
  accessToken,
  module,
  userInfo,
  commonPayload,
  setIsNugget,
}: {
  accessToken: string;
  module: any;
  userInfo?: IUserInfo;
  commonPayload?: any;
  setIsNugget?: (isNugget: boolean) => void;
}) => {
  const { masters } = useMasterContext();

  useEffect(() => {
    const userAssignedBranches =
      masters?.userAssignedBranches?.map((el: any) => el.value).join(",") || "";

    const meta =
      userInfo && userInfo.user_name
        ? {
            ticketProperties: {
              cf_name: [userInfo.user_name],
              cf_email: [userInfo.email],
              cf_employee_id: [userInfo.employeeId],
              cf_role: [userInfo.fexRole],
              cf_branch: [userAssignedBranches],
              cf_stream: [
                userInfo.idToStreamName
                  ? Object.values(userInfo.idToStreamName).join(",")
                  : "",
              ],
              cf_subject: [
                userInfo.subjects?.map((el: any) => el.subjectName).join(",") ||
                  "",
              ],
            },
            botPayloadProperties: {
              cp_module: [routeToModuleMap[module]],
              cp_name: [userInfo.user_name],
              cp_email: [userInfo.email],
              cp_employee_id: [userInfo.employeeId],
              cp_role: [userInfo.fexRole],
              cp_branch: [userAssignedBranches],
              cp_stream: [
                userInfo.idToStreamName
                  ? Object.values(userInfo.idToStreamName).join(",")
                  : "",
              ],
              cp_subject: [
                userInfo.subjects?.map((el: any) => el.subjectName).join(",") ||
                  "",
              ],
            },
            supportHubPayloadProperties: {
              cp_module: [routeToModuleMap[module]],
            },
          }
        : {
            ticketProperties: {},
            botPayloadProperties: { cp_module: [routeToModuleMap[module]] },
            supportHubPayloadProperties: {
              cp_module: [routeToModuleMap[module]],
            },
          };

    const initializeNuggetChat = () => {
      if (window.NuggetChat) {
        console.log(
          "NuggetChat: initialized, module: ",
          module,
          routeToModuleMap[module]
        );
        window.NuggetChat.init({
          ...commonPayload,
          accessToken: accessToken,
          meta,
          onWidgetCollapse: handleResolvedEventToggle,
        });
      }
    };
    const handleResolvedEventToggle = () => {
      if (setIsNugget) {
        setIsNugget(false);
        console.log("NuggetChat: Mobile: toggle");
      }
    };

    const handleResolvedEvent = () => {
      if (window.NuggetChat?.toggle) {
        console.log("NuggetChat: Resolved event triggered: toggle");
        window.NuggetChat.toggle();
      }
    };

    const handleMessage = (event: MessageEvent) => {
      // if (event.origin !== "https://aakash.nugget.com/user/chat-embed.js")
      //   return;

      if (event.data.type === "CSAT_SUBMITTED_EVENT") {
        setTimeout(() => {
          handleResolvedEvent();
        }, 5000);
      }
    };

    let inactivityTimer: NodeJS.Timeout;

    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        if (window.NuggetChat?.toggle) {
          console.log("NuggetChat: toggle event triggered: inactive for 5min");
          //window.NuggetChat.toggle();
        }
        window.removeEventListener("message", handleMessage);
      }, 3000000); // 60 seconds of inactivity
    };

    // Reset the timer on user activity
    window.addEventListener("mousemove", resetInactivityTimer);
    window.addEventListener("keydown", resetInactivityTimer);

    // Initialize NuggetChat and set the initial timer
    initializeNuggetChat();
    resetInactivityTimer();

    // Add message listener for iframe communication
    window.addEventListener("message", handleMessage);

    // Cleanup function
    return () => {
      clearTimeout(inactivityTimer);
      if (window.NuggetChat?.destroy) {
        console.log("NuggetChat: destroy event triggered: cleanup");
        window.NuggetChat.destroy();
      }
      window.removeEventListener("message", handleMessage);
      window.removeEventListener("mousemove", resetInactivityTimer);
      window.removeEventListener("keydown", resetInactivityTimer);
    };
  }, [accessToken, module, masters?.userAssignedBranches, userInfo]);

  return null;
};

export default NuggetChatWidget;
